import TaskActionButton from "@/pages/get-don/task-actions/TestActionButton.tsx";
import TaskLoading from "@/pages/get-don/components/cards/GetDonCardLoading.tsx";
import { useTranslation } from "react-i18next";
import TaskCard from "@/components/common/tasks/TaskCard.tsx";
import NoData from "@/components/common/NoData";
import { useHomePage } from "../api";

// const TasksList = (props: TaskListProps) => {
//   return (
//     <Suspense
//       fallback={
//         <div className="grid gap-1">
//           {Array.from({ length: 3 }).map((_, idx) => (
//             <TaskLoading key={idx} />
//           ))}
//         </div>
//       }
//     >
//       <BaseTasksList {...props} />
//     </Suspense>
//   );
// };

const HomeTaskList = () => {
  const { t } = useTranslation();
  const { data, isLoading } = useHomePage();

  if (isLoading) {
    return (
      <div className="grid gap-1">
        {Array.from({ length: 3 }).map((_, idx) => (
          <TaskLoading key={idx} />
        ))}
      </div>
    );
  }

  if (!data?.tasks.length) {
    return (
      <NoData
        image={<img src="images/common-no-data.png" className="size-24" />}
        title={t("no_data_title")}
        description={t("no_data_subtitle")}
        headerClassName="bg-none p-0 m-0"
      />
    );
  }

  return (
    <div className="flex flex-col overflow-hidden">
      {data.tasks.map((item, index) => (
        <TaskCard
          key={index}
          {...item}
          actionComponent={<TaskActionButton task={item} />}
        />
      ))}
    </div>
  );
};

export default HomeTaskList;
